import React from 'react';
import { Helmet } from "react-helmet";

export const AddressOfUse = () => {
  return (
    <div id="about">
      <Helmet>
        <title>ABX Shipping - Dirección en USA</title>
      </Helmet>
      <div className="container">
        <div className="row align-items-center">
          {/* Texto a la izquierda */}
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>Dirección en USA</h2>
              <p>
                Utiliza nuestra dirección para hacer tus compras en USA y
                recíbelas en Perú.
              </p>
              <h3>Detalles de la Dirección</h3>
              <div className="list-style">
                <ul>
                  <li>
                    <strong>Nombre:</strong> AIRBOX + NOMBRES Y APELLIDOS Ó
                    AIRBOX + RAZÓN SOCIAL
                  </li>
                  <li>
                    <strong>Dirección:</strong> 1350 NW 121ST AVENUE
                  </li>
                  <li>
                    <strong>Suite:</strong> SUITE 700
                  </li>
                  <li>
                    <strong>Ciudad:</strong> MIAMI
                  </li>
                  <li>
                    <strong>Estado:</strong> FLORIDA
                  </li>
                  <li>
                    <strong>País:</strong> ESTADOS UNIDOS
                  </li>
                  <li>
                    <strong>Código Postal:</strong> 33182
                  </li>
                  <li>
                    <strong>Teléfono:</strong> 786 345 2727
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Imagen a la derecha */}
          <div className="col-xs-12 col-md-6">
            <img
              src="/img/addressOfUse.jpg"
              className="img-responsive address-img"
              alt="Dirección en USA"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
